// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as _ from "lodash";
import * as React from "react";

import { Grid } from "semantic-ui-react";

import DashboardGridCell from "../DashboardGridCell";

const DashboardGridView = (props) => {
	const { widgets, onCreate, onDelete } = props;

	return (
		<Grid>
			<Grid.Row columns={3}>
				<Grid.Column>
					<DashboardGridCell
						view={7}
						position={1}
						widget={_.find(widgets, { position: 1 })}
						onCreate={onCreate}
						onDelete={onDelete}
					/>
				</Grid.Column>
				<Grid.Column>
					<DashboardGridCell
						view={7}
						position={2}
						widget={_.find(widgets, { position: 2 })}
						onCreate={onCreate}
						onDelete={onDelete}
					/>
				</Grid.Column>
				<Grid.Column>
					<DashboardGridCell
						view={7}
						position={3}
						widget={_.find(widgets, { position: 3 })}
						onCreate={onCreate}
						onDelete={onDelete}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row columns={3}>
				<Grid.Column>
					<DashboardGridCell
						view={7}
						position={4}
						widget={_.find(widgets, { position: 4 })}
						onCreate={onCreate}
						onDelete={onDelete}
					/>
				</Grid.Column>
				<Grid.Column>
					<DashboardGridCell
						view={7}
						position={5}
						widget={_.find(widgets, { position: 5 })}
						onCreate={onCreate}
						onDelete={onDelete}
					/>
				</Grid.Column>
				<Grid.Column>
					<DashboardGridCell
						view={7}
						position={6}
						widget={_.find(widgets, { position: 6 })}
						onCreate={onCreate}
						onDelete={onDelete}
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

DashboardGridView.cells = 6;

export default DashboardGridView;
